import { strToStatus } from '@/_schemas/status-input';

import { strToAuthenticationType } from '../components/authentication-type';
import { type ConnectedAppFormSchema, type ConnectedAppQuerySchema } from '../schemas';
import type { APIKeyFormSchema, APIKeyQuerySchema } from '../schemas/api-keys-schemas';
import { strToEnvironment } from '../schemas/api-keys-schemas/environment-schema';

export function connectedAppQueryToForm({
  description,
  api_keys,
  client_secret,
  authorization_url,
  client_id,
  ...data
}: ConnectedAppQuerySchema): ConnectedAppFormSchema {
  return {
    ...data,
    description: description || '',
    api_keys: apiKeyQueryToForm(api_keys ?? []),
    authentication_type: strToAuthenticationType(data.authentication_type),
    client_secret: client_secret || '',
    authorization_url: authorization_url || '',
    client_id: client_id || '',
  };
}

export function apiKeyQueryToForm(apiKeys: APIKeyQuerySchema[]): APIKeyFormSchema[] {
  return apiKeys.map(({ created_by_id: _, last_updated_by_id: __, ...apiKey }) => ({
    ...apiKey,
    environment: strToEnvironment(apiKey.environment),
    status: strToStatus(apiKey.status),
  }));
}
